module.exports = __webpack_public_path__ + "static/media/google.066d8086.png";